<top-menu [showPrint]="false"></top-menu>
<div class="wrap920">
  <tip-text  [type]="'tip'" [head]="'Tip:'" [body]="'Anyone with Administrator or Team Leader access to the account can access the budget.\nWorkforce access is restricted to specifically invited users who have program access to the event or the event owner.'"></tip-text>

  <add-manage-wrapper class="adder" *ngIf="{ workers: budget?.workforceEmails | idsToItems: workersByEmail } as vars"
    [hideHRule]="true"  
    [useH3ForTitle]="true"
    [wrapperTitle]="'Budget Access'" 
    [openLabel]="'MANAGE BUDGET WORKERS'"
    [readOnly]="!canEditBudgetUsers || closed" 
    (open)="inviteFromWorkforce($event)"
    >
    <worker-card *ngIf="workersByUId[event?.owner_uid] as owner" 
      [worker]="owner" 
      [disableSelect]="true"
      [titleAddedText]="' (Event Owner)'"
    ></worker-card>
    <ng-container *ngIf="!!adminWorkforceIds.size">
      <worker-card *ngFor="let id of adminWorkforceIds" 
        [worker]="workersByUId[id]" 
        [disableSelect]="true"
        [titleAddedText]="account.admin.includes(id) ? ' (Administrator)' : ' (Team Leader)'"
      ></worker-card>
    </ng-container>
    <div class="empty-text hint" *ngIf="!vars.workers?.length">No additional workforce members.</div>
    <ng-container *ngFor="let worker of vars.workers">
      <worker-card *ngIf="programWorkforceEmails.has(worker.email)" [worker]="worker" [disableSelect]="true"></worker-card>
    </ng-container>
    
</add-manage-wrapper>
</div>
<loader-pane-fragment [trace]="traceNames.viewBudgetAdmin"></loader-pane-fragment>